import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson17: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[6.19rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson16"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">
            Airdrop Farming
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson18"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center w-[92%] mr-[4%] max-w-[110rem] text-justify text-gainsboro-100 font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <span className="text-[1.56rem] font-dm-sans text-gainsboro-100">
              DeFi Airdrops Guide
            </span>
          </p>
          <p className="m-0">
            <span className="text-[1.56rem] font-dm-sans text-gainsboro-100">
              &nbsp;
            </span>
          </p>
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans text-white">
              What Is An Airdrops
            </b>
          </p>
          <p className="m-0">
            <span className="text-[1.56rem] font-dm-sans text-gainsboro-100">
              &nbsp;
            </span>
          </p>
          <p className="m-0">
            <span className="text-[1.56rem] font-dm-sans text-gainsboro-100">
              A cryptocurrency airdrop is a marketing strategy that involves
              sending coins or tokens to wallet addresses. Small amounts of the
              new virtual currency are sent to the wallets of active members of
              the blockchain community for free or in return for a small
              service, such as retweeting a post sent by the company issuing the
              currency. The ultimate goal of a crypto airdrop is to promote
              awareness and circulation of a new token or coin.
            </span>
          </p>
          <p className="m-0">
            <span className="text-[1.56rem] font-dm-sans text-gainsboro-100">
              &nbsp;
            </span>
          </p>
          <p className="m-0">
            <span className="text-[1.56rem] font-dm-sans text-gainsboro-100">
              Airdrops are generally promoted on the company's website, social
              media, and cryptocurrency forums. Coins or tokens are sent only to
              specific wallets based on the blockchain network or coins held in
              existing wallets.
            </span>
          </p>
          <p className="m-0">
            <span className="text-[1.56rem] font-dm-sans text-gainsboro-100">
              &nbsp;
            </span>
          </p>
          <p className="m-0">
            <span className="text-[1.56rem] font-dm-sans text-gainsboro-100">
              To qualify for the free gift, a recipient may need to hold a
              minimum quantity of the crypto coins in their wallet.
              Alternatively, they may need to perform a certain task, such as
              posting about the currency on a social media forum, connecting
              with a particular member of the blockchain project, or writing a
              blog post.
            </span>
          </p>
          <p className="m-0">
            <span className="text-[1.56rem] font-dm-sans text-gainsboro-100">
              &nbsp;
            </span>
          </p>
          <p className="m-0">
            <span className="text-[1.56rem] font-dm-sans text-gainsboro-100">
              &nbsp;
            </span>
          </p>
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans text-white">
              AIRDROP FARMING
            </b>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>Why do projects give away tokens for free:</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                SEC violations can harm a project, especially if tokens are
                treated as securities. Projects opt for airdrops or other forms
                of rewarding users instead of token sales. Airdrops generate
                hype and FOMO, attracting attention to the project. Projects
                allocate a few percent of their tokenomics for giveaways to show
                appreciation for early adopters and earn a good reputation. Not
                valuing early adopters can result in FUD and decreased interest
                in the product.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                {`How to Find & Analyze a Project That Offers an airdrop:`}
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                {`When considering a project, the amount of investment it has received is crucial. Check which well-known funds have invested using a table like `}
              </span>
            </span>
            <a
              className="text-[inherit]"
              href="https://airtable.com/embed/shrX5Q7HqIo7hrljW/tblaqYnoeg5wjGxqB/viwnUA3uhNurmtgNj"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">
                    https://airtable.com/embed/shrX5Q7HqIo7hrljW/tblaqYnoeg5wjGxqB/viwnUA3uhNurmtgNj
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>. This table can also be used to find early gems.</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                {`Identify actions to increase your chances of getting the maximum airdrop reward. Read about how Paraswap made only 20,000 wallets out of 1,300,000 eligible for the airdrop - `}
              </span>
            </span>
            <a
              className="text-[inherit]"
              href="https://medium.com/paraswap/whats-an-active-user-clarifying-psp-token-distribution-filtering-logic-81df6096d410"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">
                    https://medium.com/paraswap/whats-an-active-user-clarifying-psp-token-distribution-filtering-logic-81df6096d410
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>.</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>{`Go to `}</span>
            </span>
            <a
              className="text-[inherit]"
              href="https://dune.com/browse/dashboards"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">
                    https://dune.com/browse/dashboards
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>
                {" "}
                to see what activities people are doing for the project. Choose
                activities that no more than 40% of users are doing to increase
                your chances of receiving the airdrop.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                To get a complete guide and alpha, just go to Twitter and use
                advanced search to find guides and interesting news from the
                project and the founder. But remember, you need to be better
                than those who follow the guide, so you shouldn't do everything
                exactly as written there, as it's just the author's assumptions.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Pay attention to how the project's founders and team treat the
                community, but don't worry if the project says there won't be
                any airdrop. All projects do that to ward off scammers.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span className="text-orangered">&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span className="text-orangered">&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans text-white">
              PSYCHOLOGICAL AIRDROP FARMING TIPS
            </b>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>
              {`Don't expect guaranteed profits from projects as it's all about potential gains, and if you don't hit the jackpot, you'll be disappointed. `}
            </span>
          </p>
          <p className="m-0">
            <span>
              Don't spread yourself too thin. Don't create 1 account across 100
              different projects because even if one project pays off well, the
              other 99 won't, and you'll lose money on fees. It's better to
              create 100 accounts in one good project that you believe in and
              are confident will pay off your investment. Don't spend your last
              bit of money on the chance to get an AIRDROP. You should
              understand that this is not a quick game, and it could take you a
              whole year or even 2-3 years to get anything out of a project.
              Therefore, don't use money that you're not willing to invest for
              such a long period of time.
            </span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>
              Evaluate the risks before investing, and only use funds that are
              free for you to invest. Wallet Warm-up Projects consider this
              factor to assess the likelihood that the wallet belongs to a real
              person. You need to create a wallet that leaves no doubt in the
              minds of the projects that it could be a Sybil account.
            </span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>Important parameters:</span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>Wallet age (date of first transaction)</span>
            </li>
            <li className="mb-[0rem]">
              <span>{`Number of transactions `}</span>
            </li>
            <li className="mb-[0rem]">
              <span>{`No connections with your other wallets `}</span>
            </li>
            <li className="mb-[0rem]">
              <span>
                {`Different tokens (including NFTs) on different networks `}
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>Relatively high balance</span>
            </li>
          </ul>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>I recommend following this process:</span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>
              {`Generate wallets -> Fund them -> Make transactions on different networks -> Obtain WEB3 passports or purchase ENS -> Repeat transactions after a week`}
            </span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>
              This way, you'll have ready-to-use wallets in a month or two.
            </span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>
              {`The most important thing to understand is that projects want to see that the wallet belongs to a real person, not just an empty Sybil account. So, participate in various events and projects, showing that you're an ordinary user. Interaction Strategies The key is to anticipate what projects might reward their users for and whether they will do so. To do this, we need to analyze numbers and statistics, and `}
            </span>
            <a
              className="text-[inherit]"
              href="https://dune.com/"
              target="_blank"
            >
              <span>
                <span className="[text-decoration:underline]">
                  https://dune.com/
                </span>
              </span>
            </a>
            <span> is perfect for that.</span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>We need to identify:</span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>Interaction patterns</span>
            </li>
            <li className="mb-[0rem]">
              <span>Transaction frequency</span>
            </li>
            <li className="mb-[0rem]">
              <span>Transaction volumes</span>
            </li>
            <li className="mb-[0rem]">
              <span>Balances in wallets</span>
            </li>
          </ul>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>
              {`For example, let's take any dashboard and set our criteria. I'll choose <30%. Analyze the statistics, consider percentages, and the number of wallets.`}
            </span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>
              Then, draw your own conclusions. In the screenshot, we can see
              that the optimal range is 20-29 transactions, but the number of
              users is too large, so it's better to aim for 30 transactions.
            </span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>
              You need to do this for each activity in the project and find the
              best interaction pattern for yourself. Then, calculate the
              expenses and compare them with your risk management.
            </span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>Common Mistakes</span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>Using the bridge back and forth immediately</span>
            </li>
            <li className="mb-[0rem]">
              <span>{`Withdrawing all the money after interacting `}</span>
            </li>
            <li className="mb-[0rem]">
              <span>
                {`Using the same patterns, amounts, and execution times for all wallets `}
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                Repeating the same actions after a certain period of time
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>You should randomize everything as much as possible.</span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>Time</span>
          </p>
          <p className="m-0">
            <span>Amounts</span>
          </p>
          <p className="m-0">
            <span>Patterns</span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>All of this should differ at least slightly.</span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>Wallet Withdrawals</span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>
              It's the same as funding. Withdraw from the same source. Later on,
              it doesn't matter how the funds move within the exchange.
            </span>
          </p>
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300" 
      href="/lesson18">
        <div className="w-full">
        <b className="inline-block flex-1 w-full relative text-center max-md:pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson17;
